'use client'

import clsx from 'clsx'

import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import {
  Sheet,
  SheetBody,
  SheetCloseButton,
  SheetContent,
  SheetOverlay,
  SheetTitle,
} from '@wartek-id/sheet'
import { Text } from '@wartek-id/text'

import { WILAYAH_NASIONAL } from '@/apis/data/statistik/wilayah'

import { SelectionItem } from './SelectionItem'
import { WilayahSelectionProps } from './types'
import { useWilayahSelection } from './useWilayahSelection'
import { WilayahSearchText } from './WilayahSearchText'

export function WilayahSelectionSheet({
  data,
  show,
  onClose,
  onSelect,
}: WilayahSelectionProps) {
  const {
    handleChangeKeyword,
    handleSelectProvince,
    handleSelectCity,
    handleSubmit,
    handleClose,

    selectedText,
    selectedCity,
    selectedProvince,
    cities,
    provincies,
  } = useWilayahSelection({
    data,
    show,
    onClose,
    onSelect,
  })

  return (
    <Sheet onClose={handleClose} isOpen={show} sheetSize="xl">
      <SheetOverlay />
      <SheetContent>
        <SheetTitle
          bordered
          as="header"
          style={{
            height: 'auto',
            minHeight: 'auto',
            padding: 0,
            flex: '1 1 auto',
          }}
        >
          <div className="flex w-full flex-col gap-2">
            <WilayahSearchText
              onChange={handleChangeKeyword}
              className="py-4 pb-0 pt-4"
            />

            {/* Breadcrumbs */}
            <div className="flex items-center gap-2 border-t px-4 py-2">
              <Text
                onClick={() => {
                  handleSelectProvince(null)
                }}
                role="button"
                tabIndex={0}
                data-testid="txt-breadcrumb-0"
              >
                {WILAYAH_NASIONAL.name}
              </Text>
              {selectedProvince ? (
                <>
                  <Icon>chevron_right</Icon>
                  <Text
                    className="truncate"
                    onClick={() => {
                      handleSelectProvince(null)
                    }}
                    role="button"
                    tabIndex={0}
                    data-testid="txt-breadcrumb-1"
                  >
                    {selectedProvince?.name}
                  </Text>
                </>
              ) : null}
            </div>
          </div>
        </SheetTitle>
        <SheetBody>
          {/* Wilayah selection */}
          <div className="flex w-full overflow-auto pb-4">
            {selectedProvince !== null ? (
              <div className="flex flex-1 flex-col gap-1 overflow-auto p-2">
                {cities &&
                  cities.length > 0 &&
                  cities.map((item) => {
                    return (
                      <SelectionItem
                        key={item.id}
                        testId={item.id}
                        text={item.name}
                        tail={true}
                        selected={
                          !!(selectedCity && selectedCity?.id === item.id)
                        }
                        onClick={() => {
                          handleSelectCity(item)
                        }}
                      />
                    )
                  })}
              </div>
            ) : (
              <div
                className={clsx(
                  'flex h-full flex-1 flex-col gap-1 border-r p-2'
                )}
              >
                {provincies &&
                  provincies.length > 0 &&
                  provincies?.map((item) => {
                    return (
                      <SelectionItem
                        key={item.id}
                        testId={item.id}
                        text={item.name}
                        selected={
                          selectedProvince !== null &&
                          // @ts-ignore
                          selectedProvince?.id === item.id
                        }
                        onClick={() => {
                          handleSelectProvince(item)
                        }}
                      />
                    )
                  })}
              </div>
            )}
          </div>

          <div className="sticky bottom-0 w-full border-t bg-white p-4">
            <Button fullWidth onClick={handleSubmit}>
              Pilih Wilayah ({selectedText})
            </Button>
          </div>
        </SheetBody>
        <SheetCloseButton data-testid="btn-close-sheet" />
      </SheetContent>
    </Sheet>
  )
}
